import { render, staticRenderFns } from "./MoleculeCardImageTextButton.vue?vue&type=template&id=bbc3e642&scoped=true"
import script from "./MoleculeCardImageTextButton.vue?vue&type=script&setup=true&lang=js"
export * from "./MoleculeCardImageTextButton.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc3e642",
  null
  
)

export default component.exports